import AppConstants from "../appConstants";
import apiService from "./apiService";

class DropdownService {
    getAllAgency(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_AGENCY_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllHeader(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_HEADER_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllLocale(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_LOCALE_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllPermission(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_PERMISSION_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllTopic(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_TOPIC_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllProfile(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_USER_PROFILE_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllSubjects(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_SUBJECTS_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllTags(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_TAGS_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllKeyReference(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_KEY_REFERENCE_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
    
      getAllCategory(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_CATEGORY_FIND_ALL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }

      getUsers(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DROPDOWN_USERS, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
      }
}

export default new DropdownService();